// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import McMcApplicationState from "@mcmc/App/Store/McMcApplicationState";
import { getEventData, hasEnoughSeats } from "@mcmc/App/Store/Selectors/ProductDetailsSelectors";
import LinkButton from "@mcmc/XDL/Components/Common/LinkButton";
import mergeToNew from "@mcmc/XDL/Utilities/xMergeToNew";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps {
    labelOverride?: string;
    extendedStyles?: ButtonPresentationProps;
}

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasProductContext &
    HasHistory;

const mapStateToProps = (state: McMcApplicationState, props: OwnProps & HasProductContext) => {
    return {
        registrationPageUrl: getPageLinkByPageType(state, "EventRegistrationPage")?.url,
        eventData: getEventData(state, props.productContext.product),
        hasEnoughSeats: hasEnoughSeats(props.productContext),
    };
};

const mapDispatchToProps = {};

export const productRegisterEventButtonStyles: ButtonPresentationProps = {};

const RegisterEventButton = ({
    productContext: {
        product: { isVariantParent, canonicalUrl },
    },
    registrationPageUrl,
    eventData,
    hasEnoughSeats,
    history,
    labelOverride,
    extendedStyles,
    ...otherProps
}: Props) => {
    const [styles] = useState(() => mergeToNew(productRegisterEventButtonStyles, extendedStyles));
    const registerClickHandler = () => {
        history.push(`${registrationPageUrl}?eventPath=${canonicalUrl}`);
    };

    let buttonText = "Register";
    if (!hasEnoughSeats) {
        buttonText = "Add to waitlist";
    }

    return (
        <>
            {(!eventData?.thirdPartyRegistration || !hasEnoughSeats) && (
                <Button {...styles} onClick={registerClickHandler} disabled={isVariantParent} {...otherProps}>
                    {translate(buttonText)}
                </Button>
            )}
            {eventData?.thirdPartyRegistration && hasEnoughSeats && (
                <LinkButton
                    {...styles}
                    href={eventData?.thirdPartyRegistration}
                    disabled={isVariantParent}
                    target="_new"
                    {...otherProps}
                >
                    {translate(buttonText)}
                </LinkButton>
            )}
        </>
    );
};

export default withProductContext(connect(mapStateToProps, mapDispatchToProps)(withHistory(RegisterEventButton)));
